<template>
  <main class="page plain">
    <page-header title="新增客户" back @back="$router.back()" />
    <section class="form-card">
      <h2>先核对手机号</h2>
      <p>已有客户会显示归属，你的客户可以直接写跟进。</p>
      <form @submit.prevent="check">
        <label class="field">
          <span>手机号</span>
          <input v-model.trim="mobile" type="tel" inputmode="tel" autocomplete="tel" maxlength="11" placeholder="请输入 11 位手机号" required />
        </label>
        <button class="button full" :disabled="busy" type="submit">
          <span v-if="busy" class="spinner" />
          {{ busy ? '正在核对' : '核对并继续' }}
          <app-icon v-if="!busy" name="arrow" />
        </button>
      </form>
      <p v-if="error" class="error-message" role="alert">{{ error }}</p>
    </section>
    <template v-if="info">
      <div class="sec-head">
        <h2>客户已在系统中</h2>
      </div>
      <div class="c-list">
        <customer-card :customer="info" :actions="false" @open="open" />
      </div>
      <p class="notice">该客户已有归属，请联系 {{ info.employee_text || '客户负责人' }} 协调跟进。</p>
    </template>
  </main>
</template>
<script>
import { canCall } from '../../common/customer'
export default {
  data() {
    return { mobile: '', busy: false, error: '', info: null }
  },
  methods: {
    async check() {
      if (this.busy) return
      this.error = ''
      this.info = null
      if (!canCall(this.mobile)) {
        this.error = '请输入正确的 11 位手机号'
        return
      }
      this.busy = true
      try {
        const r = await this.$api.post('/api/customer/check', { mobile: this.mobile })
        if (r.check) this.$router.push('/customer/create/' + this.mobile)
        else if (r.info && r.info.is_my)
          this.$router.push('/customer/edit/' + r.info.id + '/customer')
        else this.info = r.info
      } catch (e) {
        this.error = e.message
      } finally {
        this.busy = false
      }
    },
    open() {
      this.$router.push('/customer/detail/' + this.info.id + '/customer')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/customer/check.vue